import type { DefaultDashboardDefinition } from './dashboard-definition';

export const salesDashboard: DefaultDashboardDefinition = {
  id: "sales.main",
  appId: "sales",
  name: "Sales dashboard",
  record: null,
  queryScope: null,
  placements: [
    {id: 'sales.top-products.default', widgetId: 'sales.top-products', placement: {x: 0, y: 9, width: 6, height: 5}},
    {id: 'sales.product-gross-profit.default', widgetId: 'sales.product-gross-profit', placement: {x: 6, y: 9, width: 6, height: 5}},
    {
      id: "sales.revenue-trend.default",
      widgetId: "sales.revenue-trend",
      placement: {
        x: 0,
        y: 0,
        width: 6,
        height: 3,
      },
    },
    {
      id: "sales.tax-rate.default",
      widgetId: "sales.tax-rate",
      placement: {
        x: 6,
        y: 0,
        width: 6,
        height: 3,
      },
    },
    {
      id: "sales.order-count.default",
      widgetId: "sales.order-count",
      placement: {
        x: 0,
        y: 3,
        width: 4,
        height: 1,
      },
    },
    {
      id: "sales.revenue.default",
      widgetId: "sales.revenue",
      placement: {
        x: 4,
        y: 3,
        width: 4,
        height: 1,
      },
    },
    {
      id: "sales.sent-orders.default",
      widgetId: "sales.sent-orders",
      placement: {
        x: 8,
        y: 3,
        width: 4,
        height: 1,
      },
    },
    {
      id: "sales.status-list.default",
      widgetId: "sales.status-list",
      placement: {
        x: 0,
        y: 4,
        width: 6,
        height: 4,
      },
    },
    {
      id: "sales.performance-report.default",
      widgetId: "sales.performance-report",
      placement: {
        x: 6,
        y: 4,
        width: 6,
        height: 4,
      },
    },
    {
      id: "sales.untaxed.default",
      widgetId: "sales.untaxed",
      placement: {
        x: 0,
        y: 8,
        width: 6,
        height: 1,
      },
    },
    {
      id: "sales.tax-amount.default",
      widgetId: "sales.tax-amount",
      placement: {
        x: 6,
        y: 8,
        width: 6,
        height: 1,
      },
    },
  ],
};
